import { apiInstance, handleApiError } from "./InstanceApi";
// import { LoginData } from "../types/loginData"; // Removed as not used in JS code

export const loginService = async (data) => {
  try {
    const response = await apiInstance.post("login", data);
    return response.data;
  } catch (error) {
    return handleApiError(error)
  }
};

export const registerService = async (data) => {
    try {
        const response = await apiInstance.post("register",data);
        return response.data;
    }catch (error) {
        return handleApiError(error)
    }
}

export const logoutService = async () => {
  try {
    const response = await apiInstance.get("logout");
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const getUserService = async () => {
  try {
    const response = await apiInstance.get("user");
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};


export const verifyAccountService = async (token) => {
  try {
    const response = await apiInstance.get(`/activate/${token}`);
    return response.data.message;
  } catch (error) {
    return handleApiError(error);
  }
};

export const generateOtp = async (data) => {
  try {
    const response = await apiInstance.post('/generate-otp', {
      email: data.email,
      code_content: data.code_content
    });
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const verifyOtp = async (data) => {
  try {
    const response = await apiInstance.post('/verify-otp', {
      email: data.email,
      otp: data.otp
    });
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const verifyOtpForForgotPassword = async (data) => {
  try {
    const response = await apiInstance.post('/verify-otp-forgot', {
      email: data.email,
      otp: data.otp
    });
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const changePassword = async (data) => {
  try {
    const response = await apiInstance.post('/change-password', {
      email: data.email,
      otp: data.otp,
      password: data.password,
      password_confirmation: data.password_confirmation
    });
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};


export const checkPayUser = async (uID) => {
  try {
    const response = await apiInstance.get('check-user/', {
      params: { uID }
    });
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};
